import React, { useEffect, useState } from "react";
import styled from "styled-components";
import MayoAvatars from "../../../../assets/MayoCharacters";
import MayoLogo from "../common//MayoLogo";
import { useNavigate, useParams } from "react-router-dom";

import bgImg from "../../../../assets/Mayo/Avatar_page_bg.png"
import { postAnalytics } from "../../../../../PatientComponents/analytics";
import axios from "axios";
import { usePatientFacing } from "../../../../flow/patientFacing/hooks/usePatientFacing";


export const SEX_OPTIONS = [
  {
    text: "Male",
    value: "Male"
  },
  {
    text: "Female",
    value: "Female"
  }
]

export const AGE_OPTIONS = [
  {
    text: "20-50",
    value: "20-50"
  },
  {
    text: "50-70",
    value: "50-70"
  },
  {
    text: "70+",
    value: "70+"
  }
]

export const AVATAR_OPTIONS = [
  // Age 20–50
  {
    sex: "Female",
    age: "20-50",
    ageAvatarVal: "baby",
    ageVal: "young",
    image: MayoAvatars.female_20_50_black,
    ethnicity: "black",
    value: "avatar1",
  },
  {
    sex: "Male",
    age: "20-50",
    ageAvatarVal: "baby",
    ageVal: "young",
    image: MayoAvatars.male_20_50_black,
    ethnicity: "black",
    value: "avatar2",
  },
  {
    sex: "Female",
    age: "20-50",
    ageAvatarVal: "baby",
    ageVal: "young",
    image: MayoAvatars.white_woman_young,
    ethnicity: "white",
    value: "avatar3",
  },
  {
    sex: "Female",
    age: "50-70",
    ageAvatarVal: "child",
    ageVal: "middle",
    image: MayoAvatars.white_woman_middle,
    ethnicity: "white",
    value: "avatar4",
  },
  {
    sex: "Male",
    age: "20-50",
    ageAvatarVal: "baby",
    ageVal: "young",
    image: MayoAvatars.white_man_young,
    ethnicity: "white",
    value: "avatar5",
  },
  {
    sex: "Male",
    age: "50-70",
    ageAvatarVal: "child",
    ageVal: "middle",
    image: MayoAvatars.white_man_middle,
    ethnicity: "white",
    value: "avatar6",
  },

  // Age 50–70
  {
    sex: "Female",
    age: "50-70",
    ageAvatarVal: "child",
    ageVal: "middle",
    image: MayoAvatars.female_50_70_black,
    ethnicity: "black",
    value: "avatar7",
  },
  {
    sex: "Male",
    age: "50-70",
    ageAvatarVal: "child",
    ageVal: "middle",
    image: MayoAvatars.male_50_70_black,
    ethnicity: "black",
    value: "avatar8",
  },

  // Age 70+
  {
    sex: "Female",
    age: "70+",
    ageAvatarVal: "teen",
    ageVal: "old",
    image: MayoAvatars.female_70_black,
    ethnicity: "black",
    value: "avatar9",
  },
  {
    sex: "Male",
    age: "70+",
    ageAvatarVal: "teen",
    ageVal: "old",
    image: MayoAvatars.male_70_black,
    ethnicity: "black",
    value: "avatar10",
  },
  {
    sex: "Female",
    age: "70+",
    ageAvatarVal: "teen",
    ageVal: "old",
    image: MayoAvatars.white_woman_old,
    ethnicity: "white",
    value: "avatar11",
  },
  {
    sex: "Male",
    age: "70+",
    ageAvatarVal: "teen",
    ageVal: "old",
    image: MayoAvatars.white_man_old,
    ethnicity: "white",
    value: "avatar12",
  },
];

function AvatarOptions({text, options, borderBetween=true, OptionComponent, select, selectedValue, gap, errorMsg }) {
  const optionsWrapperStyle = gap ? {gap} : {};

  return (
    <OptionContainer>
      {errorMsg &&
        <OptionText style={{color: "#F02A4C", fontSize: 16}}>
          {errorMsg}
        </OptionText>
      }
      <OptionText>{text}</OptionText>
      <OptionsWrapper
        style={optionsWrapperStyle}
      >
      { options && 
        options.map((option, index) => {
          const isSelected = option.value === selectedValue;
          return <React.Fragment key={index}>
            <OptionComponent 
              onClick={() => !isSelected && select(option)}
              isSelected={isSelected}
              {...option}
              >
            </OptionComponent>
            {borderBetween && index < (options.length - 1) && <OptionGap />}
          </React.Fragment>
        })
      }
      </OptionsWrapper>

    </OptionContainer>
  )
}

function TextOption({text, onClick, isSelected=false}) {
  const style = isSelected ? {opacity: "100%", color: "#82A4FC"} : {};
  return (
    <TextOptionStyled
      onClick={onClick}
      style={style}
    >
      {text}
    </TextOptionStyled>
  );
}

function AvatarOption({image, onClick, isSelected=false}) {
  const borderStyle = isSelected ? {} : {};
  return (
    <Avatar 
      selected={isSelected}
      onClick={onClick}
      src={image}
    />
  );
}

export default function MayoChooseAvataV2() {
  const { getEventDataLocal } = usePatientFacing();
  const event = getEventDataLocal();

  const eventId = event?.id;
  const caseId = event?.Case.id;
  const navigate = useNavigate();

  const [selectedSex, setSelectedSex] = useState(null);
  const [selectedAge, setSelectedAge] = useState(null);
  const [selectedAvatar, setSelectedAvatar] = useState(null);

  const [enableChoiceError, setEnableChoiceError] = useState(false);

  const buttonEnabled = selectedSex && selectedAge && selectedAvatar;

  const selectOption = (setOption) => (value) => {
    if(setOption != setSelectedAvatar) {
      setSelectedAvatar(null);
    } else if(selectedAge == null || selectedSex == null) {
      setEnableChoiceError(true);
      return;
    }
    setOption(value);
  }

  const loadEventData = async () => {
    if(!event) return;
    const { gender } = event?.Case?.Avatar || {};

    // Avatar Already Selected - skip to next page
    if(gender) {
      navigate(`/patient/mayo/video_page1/${eventId}`);
    }
    setEventData(eventData);
  }
  
  useEffect(() => {
    if(selectedAge && selectedSex && enableChoiceError) {
      setEnableChoiceError(false);
    }
  }, [selectedAge, selectedSex])

  useEffect(() => {
    loadEventData()
  }, [event]);

  const filteredAvatarOptions = AVATAR_OPTIONS.filter(avatar => {
    return (
      (selectedSex ? selectedSex === null || avatar.sex === selectedSex.value : true) &&
      (selectedAge ? selectedAge == null || avatar.age === selectedAge.value : true)
    );
  });

  const submitAvatar = async () => {
    if(!selectedAvatar) {
      // Todo - add error message
      return;
    }

    const gender = selectedSex.value.toLowerCase(); 
    const age = selectedAvatar.ageAvatarVal;
    const ethnicity = selectedAvatar.ethnicity;

    await axios.post("/api/avatar", {
      caseId, gender, age, ethnicity
    });
    await postAnalytics(caseId, "avatarSelected");

    navigate(`/patient/mayo/video_page1/${eventId}`);
  }
  
  return(
    event &&
    <Container>
      <MayoLogo/>
      <Title>Choose your avatar</Title>
      <AvatarForm>
        <AvatarOptions 
          text="Choose your sex"
          OptionComponent={TextOption}
          borderBetween={true}
          options={SEX_OPTIONS}
          select={selectOption(setSelectedSex)}
          selectedValue={selectedSex?.value}
        />
        <HL/>
        <AvatarOptions 
          text="Choose your age"
          OptionComponent={TextOption}
          borderBetween={true}
          options={AGE_OPTIONS}
          select={selectOption(setSelectedAge)}
          selectedValue={selectedAge?.value}
        />
        <HL/>
        <AvatarOptions
          errorMsg={enableChoiceError ? "Please fill the previous fields first" : null}
          gap={13}
          borderBetween={false}
          text="Choose your preferred avatar"
          OptionComponent={AvatarOption}
          options={filteredAvatarOptions}
          select={selectOption(setSelectedAvatar)}
          selectedValue={selectedAvatar?.value}
        />
      </AvatarForm>
      <Button onClick={submitAvatar}
        style={buttonEnabled && {opacity: 1}}
      >Next</Button>
    </Container>
  );
}

const Container = styled.div`
  font-family: Abraham;
  min-height: 100vh;
  background-image: url("${bgImg}");
  background-repeat: repeat;
  background-size: cover;
  background-position: center;
`

const Title = styled.p`
  margin: 0;
  margin-bottom: 20px;
  margin-top: 25px;
  margin-left: 29px;

  font-size: 24px;
  font-weight: 600;
  color: #222222;
`

const AvatarForm = styled.div`
  margin-inline: 18px;
  border-radius: 15px;
  background-color: #FFFFFF;
  backdrop-filter: blur(6px);
  box-shadow: 0 3px 6px #0000001A;

  padding: 28px 0 30px 19px;
`

const OptionContainer = styled.div`
`

const OptionsWrapper = styled.div`
  display: flex;
  gap: 20px;
  align-items: center;
  overflow: hidden;
`

const OptionText = styled.p`
  margin: 0;
  margin-bottom: 14px;
  
  font-size: 19px;
  color: #222222;
`

const OptionGap = styled.div`
  min-width: 1px;
  height: 18px;
  background-color: #EAEAEA;
`

const TextOptionStyled = styled.p`
  margin: 0;
  color: #222222;
  font-size: 19px;
  opacity: 40%;
`

const Avatar = styled.img`
  border-radius: 50%;
  border: 2px solid ${({ selected }) => (selected ? "#84a4fc" : "transparent")};
  margin-top: 10px;
  width: 75px;
  height: 75px;
`;

const Button = styled.button`
  opacity: 50%;
  background-color: #F02A4C;
  color: white;
  font-size: 17px;

  display: block;
  border-radius: 19px;
  border: 0;
  width: 135px;
  height: 37px;
  margin-inline: auto;
  margin-top: 58px;
`

const HL = styled.div`
  height: 1px;
  background-color: #EAEAEA;
  margin-block: 18px;
`